<template>
  <div class="page-contacts-adresses">
    <div class="page-contacts-adresses__column">
      <!-- Address Block -->
      <div
        v-for="(address, index) in leftAddresses"
        :key="index"
        class="page-contacts-adresses__block"
        :class="{
          'm-top-6': index > 0,
        }"
      >
        <h2 class="text-xl">
          {{ address.companyAddressType }}
        </h2>
        <div class="text-m" v-html="address.companyAddressContent"></div>
      </div>

      <!-- Cta -->
      <PagesContactsRequestCta class="hide-for-small" />
    </div>
    <div class="page-contacts-adresses__column">
      <!-- Address Block -->
      <div
        v-for="(address, index) in rightAddresses"
        :key="index"
        class="page-contacts-adresses__block"
        :class="{
          'm-top-6': index > 0,
        }"
      >
        <h2 class="text-xl">
          {{ address.companyAddressType }}
        </h2>
        <div class="text-m" v-html="address.companyAddressContent"></div>
      </div>

      <!-- Cta -->
      <PagesContactsRequestCta class="show-for-small" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesContactsAddresses',
}
</script>

<script setup>
const props = defineProps({
  addresses: Object,
})

const key = 'showroom'

const leftAddresses = computed(() => {
  return props.addresses.filter((address) => address.companyAddressMeta === key)
})

const rightAddresses = computed(() => {
  return props.addresses.filter((address) => address.companyAddressMeta !== key)
})
</script>

<style lang="scss">
@import './style.scss';
</style>
